var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgR6Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00189 5.27907V18.785C6.00189 18.785 5.78427 22.0157 10.7721 21.9059C10.7721 21.9059 15.2588 22.447 15.8239 18.8928V10.3089C15.8239 10.3089 15.4764 8.55372 12.4194 8.55372C12.4194 8.55372 10.3169 8.5098 10.209 9.18269L10.1871 5.80021C10.1871 5.80021 10.86 5.04145 11.7266 5.82217L11.7046 7.83888H15.8239V5.27907C15.8239 5.27907 15.8139 1.85466 10.9738 2.04834C10.9717 2.04834 6.37129 1.65897 6.00189 5.27907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23225 13.2361V19.4359H9.10645V19.7694H9.43591V19.8912H10.4243V19.7554H10.5561V16.5306C10.5561 16.5306 10.9135 16.0614 11.7401 16.1653V14.48C11.7401 14.48 12.459 14.1106 13.7908 14.1106V12.5691C13.7908 12.5691 13.2956 11.8643 12.1455 12.651C12.1455 12.651 10.8316 13.3699 10.5541 12.5632H9.46987V12.671H9.22628V12.8987H9.10847V13.1503H9.22827L9.23225 13.2361Z",
    fill: "#191B2A",
    stroke: "#191B2A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6602 15.0811V16.0295H11.6286V14.7156L11.4928 14.478H11.2692L11.2752 14.7016C11.2752 14.7016 11.5048 14.7416 11.5328 14.8853L11.4469 14.9672C11.4489 14.9652 11.2013 14.5939 10.6602 15.0811Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.824,
    height: 20,
    fill: "white",
    transform: "translate(6 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR6Logo);
export default __webpack_public_path__ + "static/media/R6_logo.2eae682fb038d244a3d0b11ac92c7079.svg";
export { ForwardRef as ReactComponent };